import React, { useState } from "react";
import reviewService  from "../services/reviewService";

export const CreateReview: React.FC = () => {
  const [form, setForm] = useState({ name: "", comment: "" });
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await reviewService.createPublic(form);
    setSuccess(true);
    setForm({ name: "", comment: "" });
  };

  return (
    <div className="container">
      <h2>Leave a Review</h2>
      {success && <p style={{ color: "green" }}>Thank you! Your review is pending approval.</p>}
      <form onSubmit={handleSubmit}>
        <input value={form.name} onChange={(e) => setForm({...form, name: e.target.value})} placeholder="Your name" required />
        <textarea value={form.comment} onChange={(e) => setForm({...form, comment: e.target.value})} placeholder="Your review" required />
        <button type="submit" className="adminAddButton">Submit</button>
      </form>
    </div>
  );
};

export default CreateReview